<template>
    <div class="main-sidebar">
      <aside id="sidebar-wrapper">
        <div class="sidebar-brand sidebar-brand-sm">
          <a href="dashboard-ecommerce.html">UI</a>
        </div>
        <ul class="sidebar-menu pt-2">

          <!-- ADMIN MENU -->
          <template v-if="user.level === 1">

            <li>
              <router-link class="nav-link" :to="{ name: 'dashboard' }">
                <i class="uil uil-dashboard"></i>
                <span>Dashbaord</span>
              </router-link>
            </li>

            <li>
              <router-link class="nav-link" :to="{ name: 'historys' }">
                <i class="uil uil-history"></i>
                <span>Historys</span>
              </router-link>
            </li>

            <li @click="menuActive(2,true)">
              <router-link class="nav-link" to="#user">
                  <i class="uil uil-users-alt"></i>
                  <span>User Management</span>
              </router-link>
            </li>

            <li @click="menuActive(3,true)">
              <router-link class="nav-link" to="#slot">
                  <i class="uil uil-ticket"></i>
                  <span>Slots Management</span>
              </router-link>
            </li>

            <li>
                <router-link class="nav-link" :to="{ name: 'website' }">
                  <i class="uil uil-window"></i>
                  <span>Website</span>
                </router-link>
            </li>

            <li>
              <router-link class="nav-link" :to="{ name: 'challenge' }">
                <i class="uil uil-award"></i>
                <span>Challenge</span>
              </router-link>
            </li>

            <li>
              <router-link class="nav-link" :to="{ name: 'bonus' }">
                <i class="uil uil-gift"></i>
                <span>Bonus</span>
              </router-link>
            </li>

            <li @click="menuActive(4,true)">
              <router-link class="nav-link" to="#events">
                  <i class="uil uil-parcel"></i>
                  <span>Events Management</span>
              </router-link>
            </li>

          </template>

          <template v-if="user.level === 2">

              <li>
                <router-link class="nav-link" :to="{ name: 'distributor-dashboard' }">
                  <i class="uil uil-dashboard"></i>
                  <span>Dashbaord</span>
                </router-link>
              </li>

              <li>
                <router-link class="nav-link" :to="{ name: 'historys' }">
                  <i class="uil uil-history"></i>
                  <span>Historys</span>
                </router-link>
              </li>

              <li>
                <router-link class="nav-link" :to="{ name: 'distributor-agent' }">
                  <i class="uil uil-users-alt"></i>
                  <span>Agents</span>
                </router-link>
              </li>

              <li>
                <router-link class="nav-link" :to="{ name: 'distributor-slot-agent' }">
                  <i class="uil uil-ticket"></i>
                  <span>Agents</span>
                </router-link>
              </li>

          </template>

          <template v-if="user.level === 3">
            <li>
              <router-link class="nav-link" :to="{ name: 'agent-leaderboard' }">
                <i class="uil uil-award"></i>
                <span>Leaderboard</span>
              </router-link>
            </li>
              
            <li>
              <router-link class="nav-link" :to="{ name: 'agent-dashboard' }">
                <i class="uil uil-dashboard"></i>
                <span>Dashbaord</span>
              </router-link>
            </li>

            <li>
              <router-link class="nav-link" :to="{ name: 'historys' }">
                <i class="uil uil-history"></i>
                <span>Historys</span>
              </router-link>
            </li>

            <li>
                <router-link class="nav-link" :to="{ name: 'agent-website', params: { id: '4gentw3bsit1' } }">
                  <i class="uil uil-window"></i>
                  <span>Website</span>
                </router-link>
            </li>

            <li @click="menuActive(8,true)">
              <router-link class="nav-link" to="#events">
                  <i class="uil uil-parcel"></i>
                  <span>Events Management</span>
              </router-link>
            </li>
          </template>

        </ul>

      </aside>

      <aside v-show="active_submenu === true" class="sub-menu">

        <!-- ADMIN MENU -->
        <template v-if="user.level === 1">
          <ul v-if="active_menu === 2" class="sidebar-sub-menu">
            <span class="mb-2 ssm-label d-block">User Management</span>
            <li @click="submenuActive(1)" :class="{'active': active_dropdown == 1}">
              <router-link class="nav-link" :to="{ name: 'admin' }"><i class="uil uil-user-md"></i> Admins</router-link>
            </li>
            <li @click="submenuActive(2)" :class="{'active': active_dropdown == 2}">
              <router-link class="nav-link" :to="{ name: 'distributor' }"><i class="uil uil-users-alt"></i> Distributors</router-link>
            </li>
            <li @click="submenuActive(3)" :class="{'active': active_dropdown == 3}">
              <router-link class="nav-link" :to="{ name: 'agent' }"><i class="uil uil-user-arrows"></i> Agents</router-link>
            </li>
          </ul>

          <ul v-if="active_menu === 3" class="sidebar-sub-menu">
            <span class="mb-2 ssm-label d-block">Slots Management</span>
            <li @click="submenuActive(4)" :class="{'active': active_dropdown == 4}">
              <router-link class="nav-link" :to="{ name: 'slot-distributor' }"><i class="uil uil-users-alt"></i> Slot Distributors</router-link>
            </li>
            <li @click="submenuActive(5)" :class="{'active': active_dropdown == 5}">
              <router-link class="nav-link" :to="{ name: 'slot-agent' }"><i class="uil uil-user-arrows"></i> Slot Agents</router-link>
            </li>
          </ul>

          <ul v-if="active_menu === 4" class="sidebar-sub-menu">
            <span class="mb-2 ssm-label d-block">Events Management</span>
            <li @click="submenuActive(81)" :class="{'active': active_dropdown == 8}">
              <router-link class="nav-link" :to="{ name: 'partner' }"><i class="uil uil-user"></i> Partner</router-link>
            </li>
            <li @click="submenuActive(6)" :class="{'active': active_dropdown == 6}">
              <router-link class="nav-link" :to="{ name: 'theme' }"><i class="uil uil-clapper-board"></i> Themes</router-link>
            </li>
            <li @click="submenuActive(7)" :class="{'active': active_dropdown == 7}">
              <router-link class="nav-link" :to="{ name: 'music' }"><i class="uil uil-music"></i> Music</router-link>
            </li>
            <li @click="submenuActive(88)" :class="{'active': active_dropdown == 88}">
              <router-link class="nav-link" :to="{ name: 'waitinglist' }"><i class="uil uil-clipboard-notes"></i> Waiting List</router-link>
            </li>
            <li @click="submenuActive(8)" :class="{'active': active_dropdown == 8}">
              <router-link class="nav-link" :to="{ name: 'event' }"><i class="uil uil-calender"></i> Event</router-link>
            </li>
          </ul>
        </template>

        <template v-if="user.level === 3">

          <ul v-if="active_menu === 8" class="sidebar-sub-menu">
            <span class="mb-2 ssm-label d-block">Events Management</span>
            <li @click="submenuActive(81)" :class="{'active': active_dropdown == 8}">
              <router-link class="nav-link" :to="{ name: 'agent-partner' }"><i class="uil uil-user"></i> Partner</router-link>
            </li>
            <li @click="submenuActive(7)" :class="{'active': active_dropdown == 7}">
              <router-link class="nav-link" :to="{ name: 'agent-music' }"><i class="uil uil-music"></i> Music</router-link>
            </li>
            <li @click="submenuActive(88)" :class="{'active': active_dropdown == 88}">
              <router-link class="nav-link" :to="{ name: 'waitinglist' }"><i class="uil uil-clipboard-notes"></i> Waiting List</router-link>
            </li>
            <li @click="submenuActive(8)" :class="{'active': active_dropdown == 8}">
              <router-link class="nav-link" :to="{ name: 'agent-event' }"><i class="uil uil-calender"></i> Event</router-link>
            </li>
          </ul>
        </template>


      </aside>
    </div>
</template>

<script>
    import {mapMutations, mapState} from 'vuex'

    export default {
      data(){
        return{
          active_menu:1,
          active_dropdown:0,
          active_submenu:false,
          isActive: false,
          window_width:0,
        }
      },
      created(){
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
      },
      computed:{
        ...mapState('AuthControl', {
            menu: state => state.menu,
            user: state => state.user
        }),
      },
      watch:{
        menu:function(val){
          if(val === false){
            this.active_submenu = false
          }
        },
      },
      methods:{
        ...mapMutations('AuthControl', ['CHANGE_MENU']),

        handleResize() {
            this.window_width = window.innerWidth;
        },
        menuActive(menu,dropdown) {
          if(dropdown === true && this.active_submenu == false){
            this.active_submenu = true
          }else if(dropdown === false || dropdown === true && this.active_submenu == true){
            this.active_submenu = false
          }

          this.active_menu = menu

          if(this.window_width < 768 && dropdown === false){
            this.CHANGE_MENU(false)
          }
        },
        submenuActive(dropdown) {
          if(this.window_width < 768 && this.active_dropdown !== dropdown){
            this.CHANGE_MENU(false)
          }

          this.active_dropdown = dropdown
        }
      },
      beforeRouteLeave (to, from, next) {
        this.active_submenu = false;
        next();
      }
    }
</script>
